export default __webpack_public_path__ + "static/media/checked-item.43999505.svg";